import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Navigation from "apps/payment/components/Navigation";
import Product from "apps/payment/components/Product";
import ProductSwitcher from "apps/payment/components/ProductSwitcher";
import ProductHeader from "apps/payment/components/ProductHeader";
import CreditPurchase from "apps/payment/containers/CreditPurchase";
import PayPalPurchase from "apps/payment/containers/PayPalPurchase";

import isApp from "shared/util/isApp";

import "./NewInfo.scss";

const NewInfo = ({
	currentScreen,
	product,
	setProduct,
	productChoices,

	navigateScreen,
	isPaypalScreen,
	isEditingInfo,
}) => {
	return (
		<div className={classnames("payment-purchase-newinfo", {
			"payment-purchase-newinfo--editing": isEditingInfo,
		})}>
			{!isApp() &&
				<div className="payment-purchase-newinfo-navigation">
					<Navigation
						currentScreen={currentScreen}
						onChangeScreen={navigateScreen}
						isEditingInfo={isEditingInfo}
					/>
				</div>
			}

			<div className="payment-purchase-newinfo-form">
				{isPaypalScreen ? <PayPalPurchase /> : <CreditPurchase />}
			</div>

			{!isEditingInfo &&
				<div className="payment-purchase-newinfo-product">
					<ProductSwitcher
						productChoices={productChoices}
						selectedProduct={product}
						onSwitchProduct={setProduct}
					/>

					<ProductHeader product={product} />

					<Product product={product} />
				</div>
			}
		</div>
	);
};


NewInfo.propTypes = {
	currentScreen: PropTypes.string.isRequired,
	product: PropTypes.object,
	isPaypalScreen: PropTypes.bool.isRequired,
	isEditingInfo: PropTypes.bool.isRequired,
	navigateScreen: PropTypes.func.isRequired,
	setProduct: PropTypes.func.isRequired,
	productChoices: PropTypes.array,
};

NewInfo.defaultProps = {
	productChoices: [],
	product: {},
};

export default NewInfo;



// WEBPACK FOOTER //
// ./src/apps/payment/components/NewInfo.jsx